import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewHeaderComponent } from './new-header.component';
import { SearchModule } from '../search/search.module';
import { LazyComponentModule } from '../shared/lazy-component';

@NgModule({
  declarations: [NewHeaderComponent],
  imports: [CommonModule, SearchModule, LazyComponentModule],
  exports: [NewHeaderComponent],
})
export class NewHeaderModule {}
